import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {
  getSecurityGroups,
  addSecurityGroup,
  updateSecurityGroup,
  deleteSecurityGroup,
  SecurityGroup,
  updateAnalyticSecurityGroupStatus,
  UpdateAnalyticStatusRequest,
  getSecurityGroupAccessControls,
  AccessControlData,
} from '../../api/endpoints/securityGroupsApi';

export interface AddSecurityGroupRequest {
  securityGroupName: string;
}

export interface UpdateSecurityGroupRequest {
  securityGroupID: number;
  securityGroupName: string;
}

//for List
export const useSecurityGroups = () => {
  return useQuery<SecurityGroup[], Error>({
    queryKey: ['securityGroups'],
    queryFn: () => getSecurityGroups(),
  });
};

//To add
export const useAddSecurityGroup = () => {
  return useMutation({
    mutationFn: (payload: AddSecurityGroupRequest) => addSecurityGroup(payload),
  });
};

//To Update

export const useUpdateSecurityGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateSecurityGroupRequest) =>
      updateSecurityGroup(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['securityGroups']});
    },
  });
};

//To Delete

export const useDeleteSecurityGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (securityGroupId: number) =>
      deleteSecurityGroup(securityGroupId),

    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['securityGroups']});
    },
  });
};

//To update Security Group Level
export const useUpdateAnalyticStatus = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateAnalyticStatusRequest) =>
      updateAnalyticSecurityGroupStatus(payload),
  });
};

export const useSecurityGroupAccessControls = (
  securityGroupId: string | null
) => {
  const parsedId = securityGroupId ? Number(securityGroupId) : undefined;

  return useQuery<AccessControlData, Error>({
    queryKey: ['securityGroupAccessControls', parsedId],
    queryFn: () => getSecurityGroupAccessControls(parsedId as number),
    enabled: !!parsedId && parsedId > 0,
  });
};
